import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppEntities } from "src/config/entities";
import { TransferOfGoodProductDto } from "../dtos/TransferOfGoodProductDto";
import { ITransferOfGoodsProductModel } from "../models/ITransferOfGoodsProductModel";
import { TransferOfGoodsModel } from "../models/TransferOfGoodsModel";
import { TransferOfGoodsService } from "src/services/documents/TransferOfGoodsService";
import { TransferOfGoodsDto } from "../dtos/TransferOfGoodsDto";

interface IProps {
  documentId?: string;
}

export const useFetchTransferOfGood = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<TransferOfGoodsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<TransferOfGoodsModel | null>(null);
  const dataService = AppEntities.TransferOfGoods.getDataService() as TransferOfGoodsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: TransferOfGoodsModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: TransferOfGoodsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: TransferOfGoodsDto | null = null;
      let responseProductDto: TransferOfGoodProductDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: TransferOfGoodsModel = {
        ...responseDto,
        products: [...responseProductDto]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
